
import React, { Fragment } from 'react'
import { withStyles, Tooltip, Typography } from '@material-ui/core'
import { Info } from '@material-ui/icons'

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip)

export const CustomTooltip = (props) => {
  const { message } = props
  return (
    <HtmlTooltip
      placement="right-start"
      title={
        <Typography color="inherit">
          <Fragment>
            { message }
          </Fragment>
        </Typography>
      }
    >
      <Info style={{ color: '#03a9f4' }} />
    </HtmlTooltip>
  )
}




// WEBPACK FOOTER //
// ./src/components/common/Tooltip.js